import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {ProductsArticleService} from './products-article.service';
import {StocksService} from './stocks.service';
import {ProductsArticle} from './products-article';
import {SerialNumber} from './serial-number-type';
import {ProductsCategoryService} from './products-category.service';
import {ProductsCategory} from './products-category';


@Component({
    selector: 'issue-stock',
    styleUrls: ['./styles/products-list.component.css'],
    templateUrl: './templates/issue-stock.component.html',
    providers: [ProductsCategoryService, ProductsArticleService, StocksService]
})



export class IssueStock {
    name = "";
    verification_serial_txt = "Tapez un numéro de série";
    operation_bt = 'Ajouter';
    serialtext: string = "";
    article_management: string = "";
    serial_management = "";
    lot_management = "";

    quantity: number = 0;
    internal_code: string;
    reference_code: string;
    name_art: string;
    category: string;
    indexofModif: number;
    id_article: number;

    ischecked: boolean = false;
    isOut: boolean = false;
    unmanaged_by_serial: boolean = true;
    add_bt: boolean = true;
    qte_disabled: boolean = true;
    valid_bt: boolean = true;
    serial_ok: string;
    edit_serial_avalable: boolean = false;

    prod_list: ProductsArticle[];
    serial_selected_list: Array<string> = [];
    serial_number_list: SerialNumber[] = [];
    cat_list: ProductsCategory[];

    constructor(private products_article_service: ProductsArticleService, private stocks_service: StocksService, private route: ActivatedRoute, private product_category_service: ProductsCategoryService) {
    }

    GetArticlesList(): void {
        this.products_article_service.GetArticlesList().then(prod_list => {this.GetArticle_cb(prod_list)});

    }

    GetCategoriesList(): void {
        this.product_category_service.GetCategoriesList().then(cat_list => this.cat_list = cat_list);

    }


    GetSerialList(id_article: number): void {
        this.stocks_service.GetSerialList(id_article).then(serial_number_list => this.serial_number_list = serial_number_list);
    }

    VerificationSerialNumberInOut(id_article: number, serial_value: string): void {
        this.stocks_service.VerificationSerialNumberInOut(id_article, serial_value).then(serial_ok => {this.Verif_in_out_cb(serial_ok)});
    }

    VerificationSerialNumberOut(id_article: number, serial_value: string): void {
        this.stocks_service.VerificationSerialNumberOut(id_article, serial_value).then(serial_ok => {this.Verif_out_cb(serial_ok); this.GetResponse(serial_ok)});
    }

    Search(): void {
        if ((this.internal_code == undefined) && (this.reference_code == undefined) && (this.name_art == undefined) && (this.category == undefined)) {
            this.GetArticlesList();
        } else {
            this.products_article_service.Search(this.internal_code, this.reference_code, this.name_art, this.category).then(prod_list => this.prod_list = prod_list);

        }
    }

    AllArticles(): void {
        this.GetArticlesList();
    }

    SetIssueOperation(product: ProductsArticle): void {
        this.serial_selected_list = [];
        this.quantity = 0;
        this.id_article = product.id_article;
        this.name = product.name;
        this.verification_serial_txt = "Tapez un numéro de série";

        if (product.managed_by_serial === 'OUT') {
            this.article_management = 'OUT';
            this.unmanaged_by_serial = false;
            this.qte_disabled = true;
            this.isOut = true;

        } else if (product.managed_by_serial === 'IN_OUT') {
            this.article_management = 'IN_OUT';
            this.qte_disabled = true;
            this.GetSerialList(this.id_article);
            this.unmanaged_by_serial = true;
            this.isOut = true;

        }
        else if (product.managed_by_serial === 'UNMANAGED_BY_SERIAL') {
            this.article_management = 'UNMANAGED_BY_SERIAL';
            this.qte_disabled = false;
            this.isOut = false;
            this.unmanaged_by_serial = true;
        }

        this.ManagementInfos(product);
    }

    ManagementInfos(product: ProductsArticle): void {
        if (product.managed_by_lot === '0') {
            this.lot_management = '( Non géré par lot -';
        } else if (product.managed_by_lot === '1') {
            this.lot_management = '( Géré par lot -';
        }
        if (product.managed_by_serial === 'OUT') {
            this.serial_management = 'géré par numéro de série en sortie )';
        } else if (product.managed_by_serial === 'IN_OUT') {
            this.serial_management = 'géré par numéro de série en entrée / sortie )';
        } else if (product.managed_by_serial === 'UNMANAGED_BY_SERIAL') {
            this.serial_management = 'non géré par numéro de série )';
        }
    }

    ChoisedArticle(product: ProductsArticle): void {
        this.SetIssueOperation(product);
        this.ManagementInfos(product);
    }

    Toggle(serial: string, selected: Array<string>): void {
        var index = selected.indexOf(serial);
        if (index > -1) {
            selected.splice(index, 1);
        }
        else {
            selected.push(serial);
        }
        this.quantity = selected.length;
    };

    Exists(serial: string, selected: Array<string>): boolean {
        return selected.indexOf(serial) > -1;
    }

    isChecked(): boolean {
        return this.serial_selected_list.length === this.serial_number_list.length;
    }

    isIndeterminate(): boolean {
        return (this.serial_selected_list.length !== 0 &&
            this.serial_selected_list.length !== this.serial_number_list.length);

    }

    toggleAll(): void {
        if (this.serial_selected_list.length === this.serial_number_list.length) {
            this.serial_selected_list = [];
        } else if (this.serial_selected_list.length === 0 || this.serial_selected_list.length > 0) {

            for (let i = 0; i < this.serial_number_list.length; i++) {
                this.serial_selected_list[i] = this.serial_number_list[i]['serial'];

            }
        }
        this.quantity = this.serial_selected_list.length;
    }

    Verif_local(): void {

        var index = this.serial_selected_list.indexOf(this.serialtext.trim());
        if (index > -1) {
            this.serialtext = "";
            this.verification_serial_txt = "Cet numéro de série est déjà dans la liste";
            setTimeout(() => {this.verification_serial_txt = "Tapez un numéro de série"}, 2000);
        }
        else {
            if (this.serialtext.trim() !== "") {
                this.serial_selected_list.push(this.serialtext.trim());
                this.serialtext = "";
                this.quantity = this.serial_selected_list.length;
            }

        }

    }



    Verif_in_out_cb(param: string): void {

        if (param === "OK") {
            this.Verif_local();
        } else {
            this.serialtext = "";
            this.verification_serial_txt = "Cet numéro de série n'existe pas";
            setTimeout(() => {this.verification_serial_txt = "Tapez un numéro de série"}, 2000);
        }

    }

    Verif_out_cb(param: string): void {

        if (param === "OK") {
            this.Verif_local();
        } else {
            this.serialtext = "";
            this.verification_serial_txt = "Cet produit a été déjà sorti";
            setTimeout(() => {this.verification_serial_txt = "Tapez un numéro de série"}, 2000);
        }

    }


    AddSerialNumber(): void {
        if (this.serialtext !== "") {
            // Test si serial ao anaty base
            if (this.article_management === "IN_OUT") {
                this.VerificationSerialNumberInOut(this.id_article, this.serialtext);
            } else {
                this.edit_serial_avalable = true;
                this.VerificationSerialNumberOut(this.id_article, this.serialtext);
            }
        }
    }

    SerialEditCtl(): void {
        if (this.serialtext === "" || this.serialtext === " ") {
            this.add_bt = true;
            this.operation_bt = "Ajouter";
        }
        else {
            this.add_bt = false;
        }
    }

    ModifyBt(serial: string): void {

        this.add_bt = false;
        this.operation_bt = "Modifier";
        this.serialtext = serial;

        this.indexofModif = this.serial_selected_list.indexOf(serial);

    }

    InitForm(): void {
        this.add_bt = true;
        this.operation_bt = "Ajouter";
        this.serialtext = "";
    }

    GetResponse(response: string): void {
        this.serial_ok = response;
    }

    MofidySerialNumber(): void {
        var index = this.indexofModif;
        this.VerificationSerialNumberOut(this.id_article, this.serialtext);
        if ((this.serial_ok === "OK")) {
            this.serial_selected_list.splice(index, 1, this.serialtext);

        }
        this.InitForm();
    }

    ButtonOperation(): void {
        if (this.operation_bt === "Ajouter") {
            this.AddSerialNumber();
        } else {
            this.MofidySerialNumber();
        }
    }

    SupprBt(serial: string): void {
        var index = this.serial_selected_list.indexOf(serial);
        if (index > -1) {
            this.serial_selected_list.splice(index, 1);
            this.quantity = this.serial_selected_list.length;
            this.InitForm();
        }
    }

    IssueStock(): void {
        var serial_list = this.serial_selected_list.join('^');
        this.stocks_service.IssueStocks(this.id_article, this.quantity, serial_list).then(prod_list => this.prod_list = prod_list['list']);
        this.serial_selected_list = [];
        this.quantity = 0;
        this.add_bt = true;
        this.name = "";
        this.serial_management = "";
        this.lot_management = "";
    }

    load_article(id: number): void {
        for (let i = 0; i < this.prod_list.length; i++) {
            if (this.prod_list[i].id_article == id) {
                this.SetIssueOperation(this.prod_list[i]);
            }
        }
    }

    GetArticle_cb(prod_list: ProductsArticle[]): void {
        this.prod_list = prod_list;
        this.route.params.subscribe((params: Params) => {
            let id = params['id'];

            if (id !== undefined) {
                this.load_article(parseInt(id));
            }
        });
    }

    ngOnInit(): void {
        this.GetArticlesList();
        this.GetCategoriesList();
    }

}



// WEBPACK FOOTER //
// ./src/app/issue-stock.component.ts